// ContractOverviewHeader — tab-level header on the Details surface.
// Title + subtitle + Duplicate / Export / Edit details action cluster.
// Edit details links to /manage/contracts/{id}/edit.
// Duplicate renders disabled (coming soon). Export opens ExportModal.

import { Link } from "react-router";
import { Pencil, Copy } from "lucide-react";
import ExportButton from "./ExportButton";

interface ContractOverviewHeaderProps {
  contractId: string;
  onDuplicate?: () => void;
}

const DUPLICATE_TOOLTIP = "Coming soon — duplicate from existing contract";

export function ContractOverviewHeader({
  contractId,
  onDuplicate,
}: ContractOverviewHeaderProps) {
  const duplicateDisabled = !onDuplicate;

  return (
    <div className="flex items-start justify-between flex-wrap gap-3 mb-6">
      <div>
        <h2 className="text-h2 text-slate-900 dark:text-slate-50">
          Contract overview
        </h2>
        <p className="text-caption text-slate-500 dark:text-slate-400 mt-1">
          Snapshot of contract health, performance, and key details
        </p>
      </div>

      <div
        role="toolbar"
        aria-label="Contract actions"
        className="flex items-center gap-2"
      >
        <button
          type="button"
          onClick={onDuplicate}
          disabled={duplicateDisabled}
          title={duplicateDisabled ? DUPLICATE_TOOLTIP : undefined}
          aria-disabled={duplicateDisabled || undefined}
          className="btn-secondary py-2 px-3 inline-flex items-center gap-1 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          <Copy className="h-4 w-4" aria-hidden="true" />
          Duplicate
        </button>
        <ExportButton contractId={contractId} />
        <Link
          to={`/manage/contracts/${contractId}/edit`}
          className="btn-primary py-2 px-3 inline-flex items-center gap-1"
        >
          <Pencil className="h-4 w-4" aria-hidden="true" />
          Edit details
        </Link>
      </div>
    </div>
  );
}

export default ContractOverviewHeader;
